module.exports = __webpack_public_path__ + "static/img/btn.5502a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market109/btn.png
// module id = 46Fv
// module chunks = 1